function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 48.5,
  y: 21.9,
  width: 3,
  height: 74.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 58.1,
  y: 14.2,
  width: 3,
  height: 73.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 67.7,
  y: 11.3,
  width: 3,
  height: 66.3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 87,
  y: 17.8,
  width: 3,
  height: 41.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 77.3,
  y: 12.1,
  width: 3,
  height: 56.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M71.7,12.5c14,0,25.3,11.4,25.3,25.3c0,7.1-3,14-8.3,18.8l0,0l0,0L50,94.7l-38.6-38l0,0l0,0C6,51.8,3,45,3,37.9 c0-14,11.4-25.3,25.3-25.3c7.5,0,14.5,3.3,19.4,9l2.3,2.7l2.3-2.7C57.1,15.8,64.2,12.5,71.7,12.5 M71.7,9.5 C63,9.5,55.2,13.5,50,19.6C44.8,13.5,37,9.5,28.3,9.5C12.7,9.5,0,22.2,0,37.9c0,8.3,3.6,15.8,9.3,21h0L50,98.9l40.7-40.1h0 c5.7-5.2,9.3-12.7,9.3-21C100,22.2,87.3,9.5,71.7,9.5L71.7,9.5z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 17.3,
  y: 38.2,
  width: 22.1,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 26.8,
  y: 28.7,
  width: 3,
  height: 22.1
}))))));

var SvgHeartPlus = function SvgHeartPlus(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/heart-plus.636a678b.svg";
export { SvgHeartPlus as ReactComponent };